import { NotebookMessages } from "@notebook/domain/models/notebook-message.model";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageGetAllUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(notebookId: string): Promise<NotebookMessages> {
        const notebookMessageResult =
            await this.notebookMessageRepository.getAll(notebookId);

        return notebookMessageResult.match(
            (notebookMessages) => notebookMessages,
            () => NotebookMessages.empty(),
        );
    }
}
